import { useContext } from "react";
import { AppContext } from "../Context";

const useDark = (): boolean => {
    const { config: { isDark } } = useContext(AppContext);
    return isDark;
}

export default useDark;